import React from 'react';
import { features } from '../data/siteData';
function WhyChooseUs() {
return (
<section className="section" id="why-choose-us">
<div className="container">
<div className="section-header">
<p className="section-subtitle">Why Choose Us</p>
<h2 className="section-title">A Team You Can Trust For Quality
Delivery</h2>
</div>
<div className="card-grid">
{features.map((feature, index) => {
const Icon = feature.icon;
return (
<div className="info-card" key={index}>
<div className="icon-wrap">
<Icon />
</div>
<h3>{feature.title}</h3>
<p>{feature.description}</p>
</div>
);
})}
</div>
</div>
</section>
);
}
export default WhyChooseUs;
